var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargedMessageEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2222 12.3529H23.7778M20.2222 14.2353H22.8889M24.6667 10C25.0203 10 25.3594 10.1487 25.6095 10.4135C25.8595 10.6783 26 11.0373 26 11.4118V15.1765C26 15.5509 25.8595 15.91 25.6095 16.1747C25.3594 16.4395 25.0203 16.5882 24.6667 16.5882H22.4444L20.2222 18V16.5882H19.3333C18.9797 16.5882 18.6406 16.4395 18.3905 16.1747C18.1405 15.91 18 15.5509 18 15.1765V11.4118C18 11.0373 18.1405 10.6783 18.3905 10.4135C18.6406 10.1487 18.9797 10 19.3333 10H24.6667Z",
    stroke: "#00FE19",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3704 7.5C18.9517 3.70327 15.2917 1 11 1C5.477 1 1 5.477 1 11C1 16.523 5.477 21 11 21C12.8215 21 14.5 20.3245 16 19.6623C17.5 19 18 18 18 18",
    stroke: "#00FE19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5C13.315 6.815 12.109 6.339 11 6.309M11 6.309C9.68 6.273 8.5 6.87 8.5 8.5C8.5 11.5 14 10 14 13C14 14.711 12.536 15.446 11 15.391M11 6.309V4.5M8 14C8.644 14.86 9.843 15.35 11 15.391M11 15.391V17.5",
    stroke: "#00FE19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargedMessageEnable);
export default __webpack_public_path__ + "static/media/charged-message-enable.2be7f1114c52c61f50810ce448b059aa.svg";
export { ForwardRef as ReactComponent };